import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { bulkGetReceiptDetails } from '../../../../redux/actions/SocietyPortal/ReceiptAction/ReceiptAction';
import ReceiptPrintPage from './components/ReceiptPrintPage';

const BulkPrintReceipts = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { bulkDetailsData, bulkDetailsLoading } = useSelector(state => state.ReceiptReducer || {});

    const receiptIds = searchParams.get('ids')?.split(',').map(Number).filter(Boolean) || [];

    useEffect(() => {
        if (receiptIds.length > 0) {
            dispatch(bulkGetReceiptDetails({ receipt_ids: receiptIds }));
        }
    }, [dispatch, receiptIds.join(',')]);

    const handlePrint = () => window.print();
    const handleBack = () => navigate(-1);

    const receipts = bulkDetailsData || [];

    if (bulkDetailsLoading || receipts.length === 0) {
        return (
            <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-bg-gray-50">
                <div className="tw-text-center">
                    <div className="tw-animate-spin tw-rounded-full tw-h-12 tw-w-12 tw-border-b-2 tw-border-indigo-600 tw-mx-auto"></div>
                    <p className="tw-text-gray-500 tw-mt-4 tw-text-sm">
                        {bulkDetailsLoading ? `Loading ${receiptIds.length} receipt(s)...` : 'No receipts to print'}
                    </p>
                    {!bulkDetailsLoading && receipts.length === 0 && receiptIds.length === 0 && (
                        <button onClick={handleBack} className="tw-mt-4 tw-text-sm tw-text-indigo-600 hover:tw-underline">Go back</button>
                    )}
                </div>
            </div>
        );
    }

    return (
        <>
            <style>{`
                @media print {
                    body { margin: 0; padding: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                    .no-print { display: none !important; }
                    .print-receipt-page { page-break-after: always; margin: 0; padding: 6mm; box-shadow: none !important; border: none !important; }
                    .print-receipt-page:last-child { page-break-after: auto; }
                    @page { size: A4; margin: 8mm; }
                }
            `}</style>

            <div className="no-print tw-bg-white tw-border-b tw-border-gray-200 tw-sticky tw-top-0 tw-z-10 tw-shadow-sm">
                <div className="tw-max-w-4xl tw-mx-auto tw-px-6 tw-py-3 tw-flex tw-items-center tw-justify-between">
                    <div className="tw-flex tw-items-center tw-gap-3">
                        <button onClick={handleBack} className="tw-p-2 tw-rounded-lg hover:tw-bg-gray-100 tw-text-gray-500">
                            <Icon icon="mdi:arrow-left" className="tw-text-xl" />
                        </button>
                        <div>
                            <h1 className="tw-text-lg tw-font-bold tw-text-gray-900">Bulk Print Receipts</h1>
                            <p className="tw-text-xs tw-text-gray-500">{receipts.length} receipt(s)</p>
                        </div>
                    </div>
                    <div className="tw-flex tw-items-center tw-gap-3">
                        <button onClick={handleBack} className="tw-px-4 tw-py-2 tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-text-sm tw-font-medium tw-text-gray-700 hover:tw-bg-gray-50">
                            Back
                        </button>
                        <button onClick={handlePrint} className="tw-flex tw-items-center tw-gap-2 tw-px-5 tw-py-2 tw-bg-indigo-600 tw-text-white tw-rounded-lg tw-text-sm tw-font-semibold hover:tw-bg-indigo-700 tw-shadow-sm">
                            <Icon icon="mdi:printer" className="tw-text-lg" /> Print All ({receipts.length})
                        </button>
                    </div>
                </div>
            </div>

            <div className="tw-bg-gray-100 tw-min-h-screen tw-py-8">
                {receipts.map((receipt, pageIdx) => (
                    <ReceiptPrintPage
                        key={receipt.receipt_id || pageIdx}
                        receipt={receipt}
                        pageIdx={pageIdx}
                        totalPages={receipts.length}
                        className={`print-receipt-page tw-max-w-4xl tw-mx-auto tw-bg-white tw-shadow-lg tw-border tw-border-gray-200 ${pageIdx < receipts.length - 1 ? 'tw-mb-8' : ''}`}
                    />
                ))}
            </div>
        </>
    );
};

export default BulkPrintReceipts;
